<template>
    <div class="box">
        <!-- 筛选条件 -->
        <div class="filtrate">
            <el-form ref="form" :model="form" label-width="90px" class="form" :inline="true">
                <el-form-item label="商户名称/编号" label-position="right">
                    <el-input v-model="form.merchantIdOrMerchantName" size="small" placeholder="请输入商户名称或编号"></el-input>
                </el-form-item>
              <el-form-item label="产品类型" label-position="right" class="marginTop">
                <el-select v-model="form.productType" placeholder="请选择产品类型" clearable>
                  <el-option label="ZPOS-电签" value="1"></el-option>
                  <el-option label="FPOS-大机" value="2"></el-option>
                  <el-option label="ZPOS-买断版" value="3"></el-option>
                  <el-option label="FPOS-买断版" value="4"></el-option>
                  <el-option label="和融通" value="5"></el-option>
                  <el-option label="合利宝" value="6"></el-option>
                  <el-option label="电银" value="7"></el-option>
                  <el-option label="联动支付" value="8"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="设备sn号" label-position="right">
                <el-input v-model="form.deviceSn" size="small" placeholder="请输入设备sn号"></el-input>
              </el-form-item>
            </el-form>
            <div class="query">
                <el-button type="primary" icon="el-icon-search" @click="queryFunc">查询</el-button>
                <el-button icon="el-icon-delete" @click="clearFunc">重置</el-button>
                <el-button v-loading="btnLoading" size="small" type="success" @click="onExport">导出</el-button>
            </div>
        </div>
      <!-- 统计 -->
      <div style="margin-top: 20px">
        <el-row :gutter="20">

          <el-col :span="6">
            <div>
              <el-statistic
                group-separator=","
                :precision="2"
                decimal-separator="."
                :value="strokeCount"
                title="总笔数(笔)"
              >
              </el-statistic>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <el-statistic
                group-separator=","
                :precision="2"
                decimal-separator="."
                :value="grossAmount"
                title="总金额(元)"
              ></el-statistic>
            </div>
          </el-col>
        </el-row>
      </div>
        <!-- 表格 -->
        <div class="tab">
            <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" :header-row-style="{ 'font-weight': 'bold', 'color': '#9196A0' }">
                <el-table-column prop="merchantName" label="商户名称" width="180">
                </el-table-column>
                <el-table-column prop="merchantNo" label="商户编号" width="180">
                </el-table-column>
                <el-table-column prop="skdjk" label="刷卡贷记卡（元）" width="180" :formatter = "stateFormat">
<!--                    <template slot-scope="scope">
                        {{ scope.row.skdjk ? scope.row.skdjk : '0.00' }}
                    </template>-->
                </el-table-column>
                <el-table-column prop="ysfdjk" label="云闪付贷记卡（元）" :formatter = "stateFormat">
<!--                    <template slot-scope="scope">
                        {{ scope.row.ysfdjk ? scope.row.ysfdjk : '0.00' }}
                    </template>-->
                </el-table-column>
                <el-table-column prop="wx" label="微信（元）" :formatter = "stateFormat">
<!--                    <template slot-scope="scope">
                        {{ scope.row.wx ? scope.row.wx : '0.00' }}
                    </template>-->
                </el-table-column>
                <el-table-column prop="zfb" label="支付宝（元）" :formatter = "stateFormat">
<!--                    <template slot-scope="scope">
                        {{ scope.row.zfb ? scope.row.zfb : '0.00' }}
                    </template>-->
                </el-table-column>
                <el-table-column prop="skjjk" label="刷卡借记卡（元）" :formatter = "stateFormat">
<!--                    <template slot-scope="scope">
                        {{ scope.row.skjjk ? scope.row.skjjk : '0.00' }}
                    </template>-->
                </el-table-column>
                <el-table-column prop="strokeCount" label="总笔数（笔）" :formatter = "stateFormat">
<!--                    <template slot-scope="scope">
                        {{ scope.row.strokeCount ? scope.row.strokeCount : '0' }}
                    </template>-->
                </el-table-column>
                <el-table-column prop="grossAmount" label="总金额（元）" :formatter = "stateFormat">
<!--                    <template slot-scope="scope">
                        {{ scope.row.grossAmount ? scope.row.grossAmount : '0.00' }}
                    </template>-->
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="paginationBox">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagelndex" :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper"
                :total="total" class="pagination">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import merchantApi from '@/api/merchant/query.js';
import {getCookie} from '@/utils/base.js';
import qs from "qs";
export default {
    data() {
        return {
            form: {
                merchantIdOrMerchantName: '', // 商户名称/编号
              deviceSn: '',//设备sn号
              productType: ''
            },
            tableData: [],
            loading: true, // 表格加载
            total: 0, // 总数
            pageSize: 10, // 条数
            pagelndex: 1, // 页数
            btnLoading:false,
            like: true,
          strokeCount: 0,
          grossAmount: 0
        }
    },
    methods: {
     stateFormat(row, column, cellValue) {
        if (cellValue) {
          return Number(cellValue)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
              return $1 + ",";
            })
            .replace(/\.$/, "");
        }
        else {
          return Number(0)
            .toFixed(2);
        }
      },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.queryListFunc();
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.pageIndex = val;
            this.queryListFunc();
        },
      // 渲染统计
      queryTotalFunc() {
        // console.log(this.pageSize)
        const params = {
          merchantIdOrMerchantName: this.form.merchantIdOrMerchantName,
          deviceSn: this.form.deviceSn,
          productType: this.form.productType
        }
        // console.log(params.pageIndex)
        // console.log({ ...params })
        // console.log('查询', merchantIdOrMerchantName);
        merchantApi.getQueryTotal({ ...params }).then(res => {
          console.log(res.data)
          this.strokeCount = res.data.strokeCount;
          this.grossAmount = Number(res.data.grossAmount);
          console.log(this.grossAmount );
          // console.log(res);
          this.loading = false;
        }).catch(err => {
          // console.log(err);
        })
      },
        // 渲染列表
        queryListFunc() {
            // console.log(this.pageSize)
            const params = {
                merchantIdOrMerchantName: this.form.merchantIdOrMerchantName,
                deviceSn: this.form.deviceSn,
                productType: this.form.productType,
                pageSize: this.pageSize,
                pageIndex: this.pageIndex,
            }
            // console.log(params.pageIndex)
            // console.log({ ...params })
            // console.log('查询', merchantIdOrMerchantName);
            merchantApi.getQuery({ ...params }).then(res => {
                this.tableData = res.data.records;
                this.total = res.data.total
                // console.log(res);
                this.loading = false;
            }).catch(err => {
                // console.log(err);
            })
        },

        // 查询按钮
        queryFunc() {
            // console.log('输入框：', this.form.name)
            this.queryListFunc();
            this.queryTotalFunc();
        },
        // 重置
        clearFunc() {
            this.form.merchantIdOrMerchantName = '';
            this.form.deviceSn = '';
            this.form.productType = '';
            this.queryListFunc();
            this.queryTotalFunc();
        },
        onExport: function() {
          let self = this;
          self.btnLoading = true
          const Params = {
            merchantIdOrMerchantName: this.form.merchantIdOrMerchantName,
            deviceSn: this.form.deviceSn,
            productType: this.form.productType,
          }
          Params.token = getCookie('token');
          let baseUrl = window.location.protocol + '//' + window.location.host;
          window.location.href = baseUrl + '/api/shop/posConsumptionRecords/posConsumptionRecords/export?' + qs.stringify(Params);
          setTimeout(() => {
            self.btnLoading = false
          }, 3000);
        },
    },
    mounted() {
        this.queryListFunc();
        this.queryTotalFunc();
    },
}
</script>

<style scoped>
.query {
    margin: 20px 0 0 30px;
}

.tab {
    padding: 20px
}

.like {
  cursor: pointer;
  font-size: 25px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/views/merchant/query/index.vue